import { useState } from 'react';

import useAxios from '../../../hooks/useAxios';
export default function FileExcelUpload() {
    const { AxiosPrivate } = useAxios()
    const [file, setFile] = useState(null);
    const [error, setError] = useState(null);
    const [progress, setProgress] = useState(0);


    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            if (validateFile(selectedFile)) {
                setFile(selectedFile);
                setError(null);
            } else {
                setFile(null);
                setError('نوع فایل نامعتبر است. لطفا یک فایل اکسل آپلود کنید.');
            }
        }
    };

    const validateFile = (file) => {
        const validTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
        return validTypes.includes(file.type);
    };

    const handleFileUpload = async () => {
        if (!file) {
            setError("لطفا یک فایل را برای آپلود انتخاب کنید.");
            return;
        }

        const formData = new FormData();
        formData.append('file', file);
        await AxiosPrivate.post('excel/artwork/store', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                setProgress(percentCompleted);
            },
        }).then(res => {
            setProgress(100);
            alert(res.data.message || "فایل با موفقیت آپلود شد");
        }).catch(err => {
            setError(err.response?.data.message || 'آپلود فایل انجام نشد. لطفا دوباره تلاش کنید.');
            setProgress(0);
        }).finally(() => setProgress(0))

    };

    return (
        <div className="centerOfParent mt-12">
            <div className="centerOfParent flex-col gap-y-4 w-full max-w-md p-4 bg-white rounded-lg shadow-lg">
                <h2 className="text-2xl font-semibold text-center text-gray-800">آپلود فایل اکسل</h2>
                <input
                    id='file'
                    type="file"
                    accept=".xlsx,.xls"
                    onChange={handleFileChange}
                    className="hidden"
                />
                <label htmlFor="file" className='w-fit block text-white bg-gradient-to-r from-cyan-500 to-blue-500 hover:bg-gradient-to-bl focus:ring-4
                 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mx-auto'>{file ? file.name : 'انتخاب'}</label>
                {progress > 0 ? (
                    <div className="w-full bg-gray-200 rounded-full dark:bg-gray-700 overflow-hidden">
                        <div className="bg-gradient-to-r from-blue-400 via-blue-600 to-blue-700 text-xs font-medium text-blue-100 text-center py-1.5 leading-none duration-300 rounded-full whitespace-nowrap" style={{ width: `${progress}%` }}>{progress}%</div>
                    </div>
                ) : <button
                    onClick={handleFileUpload}
                    className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br w-1/2
                 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 shadow-lg shadow-blue-500/50 dark:shadow-lg dark:shadow-blue-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                >
                    آپلود
                </button>}
                {error && <p className="text-sm text-right text-red-600">{error}</p>}
            </div>
        </div>
    );
}
